import { OrangeButton, PrimaryButton } from 'components/Button';
import styled from 'styled-components';

export const StyledPrimaryButton = styled(PrimaryButton)`
  && {
    margin-bottom: 50px;
  }
`;

export const StyledOrangeButton = styled(OrangeButton)`
  && {
    margin-top: 10px;
  }
`;
